// services.ts — złożenie warstwy dostępu do danych i tożsamości w jednym miejscu.
//
// Testy podmieniają `fetchImpl` i dostają realny kod klienta z atrapą transportu —
// nie atrapę klienta. Dzięki temu test kontraktu sprawdza to, co poleci na produkcję.

import { ApiClient, type ApiClientDeps } from './api/client';
import { createCcAuthProvider } from './auth/ccAuthProvider';
import { TokenStore, tokenStore as defaultTokenStore } from './auth/tokenStore';
import type { AuthProvider } from './auth/types';

export interface Services {
  api: ApiClient;
  /** Wszystkie systemy tożsamości, do których Control Center potrafi się zalogować. */
  providers: readonly AuthProvider[];
  tokens: TokenStore;
}

export function createServices(deps: Omit<ApiClientDeps, 'getToken'> & { tokens?: TokenStore } = {}): Services {
  // ŻADNEGO DOSTAWCY TOKENA. Sesja Control Center jedzie ciasteczkiem httpOnly, którego skrypt
  // strony nie czyta i nie może zgubić. Magazyn tokenów zostaje w konstruktorze wyłącznie po to,
  // żeby testy mogły podać własny — w aplikacji nikt do niego nie sięga.
  const tokens = deps.tokens ?? new TokenStore();
  void tokens;
  const api = new ApiClient(deps);
  return {
    api,
    // JEDEN dostawca tożsamości. Nie „pierwszy z listy" — jedyny, jaki istnieje.
    providers: [createCcAuthProvider(api)],
    tokens,
  };
}

/** Instancja produkcyjna aplikacji. */
export const services: Services = createServices({ tokens: defaultTokenStore });
